import ActionTypes from "../constants/ActionTypes";

const defaultState = {
    loading: false,
    error: null,
    events: [],
};

const eventsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_EVENTS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.FETCH_EVENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                events: action.events,
            };
        case ActionTypes.FETCH_EVENTS_FAIL:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default eventsReducer;
